export default __webpack_public_path__ + "static/media/langInactive.b7846c87.svg";